import React from "react";
import groupAvatar from "../../../assets/images/women.png";
import media from "../../../assets/images/placeholder.jpeg";
import Checkbox from "../../../components/Checkbox";
import Icon from "../../../components/Icon";
import {getInitials} from "../../../utils/common";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {getLeadFieldName, currencyFormatter,getLeadUsageInfo, mobileNumberMusk, getSessionValue} from "../../../../../Common/Appcommon";
import dateFormat from "dateformat";
import cx from "classnames";
import { format } from 'date-fns';

const groups = [
	{
		name: "Group 1",
		avatar: groupAvatar,
		members:
			"Michelle Obama, Sandra Bullock, Kerry Washington, Beyonce Knowles, Kamala Harris, You",
	},
	{
		name: "Group 2",
		avatar: groupAvatar,
		members:
			"Michelle Obama, Sandra Bullock, Kerry Washington, Beyonce Knowles, Kamala Harris, You",
	},
	{
		name: "Group 3",
		avatar: groupAvatar,
		members:
			"Michelle Obama, Sandra Bullock, Kerry Washington, Beyonce Knowles, Kamala Harris, You",
	},
];

const Profile =  ({ user,profileFields,onChangeLeadUsage }) => {
	const contactName = "Contact_Name"; //getLeadFieldName('contactname');
	const mobileNo = "Mobile"; //getLeadFieldName('mobile');
	const emailAddress = "Email"; //getLeadFieldName('emailAddress');
	const contactForm = process.env.REACT_APP_CONTACT_FORMNAME;
	let tableid = `${contactForm}_id`; //getLeadFieldName('id');
	tableid = user[tableid];
	let updatedon = user['updatedon'];
	if(updatedon !== undefined && updatedon !== "" && updatedon !== null){
		updatedon = dateFormat(updatedon, 'dd mmm yyyy');
	}

	return (
		<div className="profile">
			<div className="profile__section profile__section--personal">
				<div className={"profile__nameinfo"}>
					<span className="roundCircle">{getInitials(user[contactName])}</span>
					{/*<div className="profile__avatar-wrapper">
					<img src={user.profile_picture} alt={user.name} className="avatar" />
				</div>*/}
					<div className={`chat__contact-wrapper`}>
						<h2 className="profile__name leadname-side-bar">
							{user[contactName]}
							<p className="chat__contact-desc mt-1">{`Last Updated: ${updatedon}`}</p>
						</h2>
					</div>
				</div>
				<div className={'profile_basicInfo'}>
					<ul className="profile__info_section">
						{
							profileFields &&
							profileFields.length > 0 &&
							(
								profileFields.map((field,index) => {
									if(user[field.fieldname] !== undefined){
										let value = user[field.fieldname];
										if(field.format !== undefined && value && value !== "0000-00-00"){
											const date = new Date(value + "Z");
											const timeZone = getSessionValue("Time_Zone");
											value = format(date, 'dd-MM-yyyy hh:mm:ss a', { timeZone });
										}
										if(field.type !== undefined && field.type == "currency" && value !== ''){
											value = currencyFormatter('en-IN', 'INR', value);
										}
										if(field.fieldname === "Mobile"){
											value = mobileNumberMusk(value);
										}
										return (
											<li className="profile-info">
												<h5>{field.labelname}:</h5>
												<p className="profileStatusBar">
													{field.class !== undefined ? <div className={`${field.class}`}>{value}</div> : value }
												</p>
											</li>
										);
									}
								})
							)
						}
					</ul>
				</div>
			</div>

			<div className="profile__section profile__section--media hide">
				<div className="sb profile__heading-wrapper">
					<h2 className="profile__heading"> Media, Links and Documents </h2>
					<button>
						<Icon id="rightArrow" className="profile__heading-icon" />
					</button>
				</div>
				<div className="profile__media-wrapper">
					<img src={media} alt="media" className="profile__media" />
					<img src={media} alt="media" className="profile__media" />
					<img src={media} alt="media" className="profile__media" />
				</div>
			</div>

			<ul className="profile__section profile__section--actions hide">
				<li className="profile__action hide">
					<p className="profile__action-left">
						<span className="profile__action-text profile__action-text--top">
							Mute Notifications
						</span>
					</p>
					<div className="profile__action-right">
						<Checkbox />
					</div>
				</li>
				<li className="profile__action">
					<p className="profile__action-left">
						<span className="profile__action-text profile__action-text--top">
							Starred Messages
						</span>
					</p>
					<button className="profile__action-right">
						<Icon id="rightArrow" className="profile__heading-icon" />
					</button>
				</li>
				<li className="profile__action">
					<p className="profile__action-left">
						<span className="profile__action-text profile__action-text--top">
							Disappearing Messages
						</span>
						<span className="profile__action-text profile__action-text--bottom">
							Off
						</span>
					</p>
					<button className="profile__action-right">
						<Icon id="rightArrow" className="profile__heading-icon" />{" "}
					</button>
				</li>
			</ul>

			<div className="profile__section profile__section--about hide">
				<div className="sb profile__heading-wrapper">
					<h2 className="profile__heading"> About and phone number </h2>
				</div>
				<ul>
					<li className="profile__about-item">
						Out here saving the world, one block of code at a time.
					</li>
					<li className="profile__about-item">+23423456789</li>
				</ul>
			</div>

			<div className="profile__section profile__section--groups hide">
				<div className="profile__heading-wrapper">
					<h2 className="sb profile__heading profile__group-heading">
						<span> Groups in common </span> <span> 3</span>
					</h2>
				</div>
				{groups.map((group) => (
					<div className="profile__group" key={group.name}>
						<div className="profile__group-avatar-wrapper">
							<img src={group.avatar} alt="Group 3" className="avatar" />
						</div>
						<div className="profile__group-content">
							<p className="profile__group-text profile__group-text--top">
								{group.name}
							</p>
							<p className="profile__group-text profile__group-text--bottom">
								{group.members}
							</p>
						</div>
					</div>
				))}
			</div>
			
			{/* <div className={cx('profile__section',{'profile__section--success': user["wsapp_blocked"] === 'Yes','profile__section--danger' : user["wsapp_blocked"] != 'Yes' })}>
				<Icon id="block" className="profile__danger-icon" />
				<p className="profile__danger-text cP" onClick={(e => {onChangeLeadUsage(tableid)})}>{user["wsapp_blocked"] === 'Yes' ? "Unblock" : "Block"} </p>
			</div> */}

			<div className="profile__section profile__section--danger hide">
				<Icon id="thumbsDown" className="profile__danger-icon" />
				<p className="profile__danger-text"> Report contact </p>
			</div>

			<div className="profile__section profile__section--danger hide">
				<Icon id="delete" className="profile__danger-icon" />
				<p className="profile__danger-text"> Delete chat </p>
			</div>
		</div>
	);
};

export default Profile;
